import React, { useEffect, useState } from 'react';

import { useMatch } from 'react-router-dom';

import { bemCssModules } from '@utils';
import { useIsMobile } from '@utils/hooks';

import { useStore, userActions } from '@modules';
import { VerificationStatusesEnum } from '@modules/user/types';

import IntroModal from '@components/IntroModal';
import Cards from '@containers/Cards';
import Wallets from '@containers/Wallets';
import MainLayout, { TMainLayout } from '@layouts/MainLayout';

import Banners from './Banners';
import Sidebar from './Sidebar';

import style from './WalletLayout.scss';

const cn = bemCssModules(style, 'WalletLayout');

export type TWalletLayout = {
  header?: React.ReactNode;
  hasSidebar?: boolean;
  additionalBanner?: React.ReactNode;
} & TMainLayout;

export const WalletLayout: CustomFC<TWalletLayout> = props => {
  const {
    header,
    hasSidebar = true,
    className,
    children,
    backButton,
    closeButton,
    additionalBanner,
  } = props;

  const isProfilePage = useMatch(CONST.nav.profile);
  const isWalletPage = useMatch(CONST.nav.wallets);
  const isProfileEditPage = useMatch(CONST.nav.profileEdit);
  const isAccountsBuyInvoiceDetailsPage = useMatch(CONST.nav.accountsBuyInvoiceDetails);

  const [{ user }, dispatch] = useStore();
  const KYCIsComplete = user.data?.checks.document === VerificationStatusesEnum.complete;
  const isMobile = useIsMobile();

  const showBanners = !(isMobile && isProfileEditPage) && !isAccountsBuyInvoiceDetailsPage;
  const isHideCards = !isProfilePage;

  const mainLayoutProps = { backButton, closeButton };

  const handleCloseIntro = () => {
    dispatch(userActions.setIsIntroModal(false));
  };

  return (
    <MainLayout {...mainLayoutProps}>
      <div className={cn({ hasSidebar }, [className])}>
        {header && <div className={cn('header')}>{header}</div>}
        {hasSidebar && (
          <Sidebar className={cn('sidebar')}>
            {KYCIsComplete && <Wallets className={cn('wallets')} />}
            <Cards className={cn('cards', { isHideCards })} />
            {showBanners && <Banners className={cn('banners')} additional={additionalBanner} />}
          </Sidebar>
        )}
        <div className={cn('content')}>{children}</div>
        {isWalletPage && <IntroModal isOpen={!!user.isIntroModal} onClose={handleCloseIntro} />}
      </div>
    </MainLayout>
  );
};

export default WalletLayout;
